import { TabsProps } from "antd";
import { useLocalizedFields } from "@/shared/form/localized-value/model/localized-field";
import { useTranslations } from "use-intl";
import { GrapesJsEditor } from "@/shared/html-template-editor/grapes-js-editor";
import { ReactNode, Suspense } from "react";

export function useTabItems(
  name: string | string[],
  propertyTree?: ReactNode,
): TabsProps["items"] | undefined {
  const { languages, localeToControlName } = useLocalizedFields();
  const t = useTranslations("LocalizedValue");

  return languages.map((locale) => {
    const langProperty = localeToControlName(locale);

    return {
      key: langProperty,
      label: t(langProperty),
      children: (
        <Suspense>
          <GrapesJsEditor
            propertyTree={propertyTree}
            editorId={`grapesjs-${langProperty}`}
            name={name}
            langProperty={langProperty}
          />
        </Suspense>
      ),
    };
  });
}
